import React from "react";
import {Link} from "react-router-dom";
import {Breadcrumbs, Typography} from "@mui/material";
import { ReactComponent as BreadcrumbsSeparator } from "../../assets/right-icon.svg";
import "./CustomBreadcrumbs.css";
import {Dropdown} from "react-bootstrap";

const CustomBreadcrumbs = ({ pages, currentPageTitle }) => {
    return (
        <>
            <Breadcrumbs className="mb-3" separator={<BreadcrumbsSeparator />} aria-label="breadcrumb">
                {pages?.map((page) => {
                    if (page.isMultiple) {
                        return (
                            <Dropdown>
                                <Dropdown.Toggle size="sm" variant="secondary" id="dropdown-basic">{page.title}</Dropdown.Toggle>

                                <Dropdown.Menu className="comment-actions__dropdown">
                                    {page.items.map((subPage) => {
                                        return <React.Fragment key={subPage.title}>
                                            <Dropdown.Item className="comment-actions__dropdown__item">
                                                <Link className="custom-breadcrumbs__item" to={subPage.to}>
                                                    {subPage.title}
                                                </Link>
                                            </Dropdown.Item>
                                        </React.Fragment>
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        );
                    } else {
                        return (
                            <Link className="custom-breadcrumbs__item" to={page.to}>
                                {page.title}
                            </Link>
                        );
                    }
                })}
                <Typography className="custom-breadcrumbs__current-page-title">{currentPageTitle}</Typography>
            </Breadcrumbs>
        </>
    );
};

export default CustomBreadcrumbs;